import React, { useEffect } from "react";
import cn from "clsx";
import { Link, Text } from "@components/ui";
import {
  EFixedBarPosition,
  TButton,
  TFixedBarPosition,
} from "@middleware/types";
import { PrismicRichText } from "@prismicio/react";
import { RichTextField } from "@prismicio/types";
import style from "./FixedBar.module.scss";

interface Props {
  button: TButton;
  text?: string | RichTextField;
  position?: TFixedBarPosition;
  className?: string;
  actionClassName?: string;
  wrapClassName?: string;
}
export default function FixedBar({
  text,
  button,
  position = EFixedBarPosition.BOTTOM,
  className,
  actionClassName,
  wrapClassName,
}: Props) {
  useEffect(() => {
    if (position === EFixedBarPosition.TOP)
      window.document.body.classList.add(style.hasFixedBar);

    return () => {
      if (position === EFixedBarPosition.TOP)
        window.document.body.classList.remove(style.hasFixedBar);
    };
  }, [position]);

  return (
    <div className={cn(className, style.bar, style[position])}>
      <div className="lk-wrap">
        <div className="lk-wrap-content">
          <div className={cn("lk-flex space-center", wrapClassName)}>
            <div className={style.boxReduction}>
              {typeof text === "string" ? (
                <Text variant="body" html={text} />
              ) : (
                <Text>
                  <PrismicRichText field={text} />
                </Text>
              )}
            </div>
            <div className={cn(actionClassName, style.boxAction)}>
              <Link
                href={button.href ?? ""}
                className="simple  white rounded maxContent "
                onClick={button.click}
              >
                {button.label}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
